import React, { Component } from 'react';
import NegotiationLotsTableList from '../Negotiation/Lots/NegotiationLotsTableList';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import DropdownListAPI from '../../API/DropdownListAPI';
import grey from '@material-ui/core/colors/grey';
import FirmPurchasesLotEditForm from './EditLots/FirmPurchasesLotEditForm';
import SnackbarAlert from '../Utils/SnackbarAlert';
import OptionalsAPI from '../../API/OptionalsAPI';
import { handleServerError } from '../../Utils/Helper';
import { FONT_FAMILY_TYPOGRAPHY, FP_MODULE } from '../../Utils/Constants';


const aquaBluePalette = createMuiTheme({
  palette: {
    primary: {
      light: '#95dedd',
      main: '#00B1AF',
      dark: '#007b7a',
      contrastText: '#ffffff'
    },
    secondary: grey,
  },
  typography: FONT_FAMILY_TYPOGRAPHY
});


export class FirmPurchasesContent extends Component {
  _isMounted;

  constructor(props) {
    super(props);
    this.state = {
      negotiationLotStateList: [],
      negotiationLot: {},
      shouldReloadList: false,
      showFPLotEditForm: false,
      openError: false,
      alertMessage: ''
    };
  }

  componentDidMount() {
    this._isMounted = true;
    const dropdownListDataAPI = new DropdownListAPI();
    const optionalsDataAPI = new OptionalsAPI();

    Promise.all([dropdownListDataAPI.getAllLotStates(FP_MODULE, false), optionalsDataAPI.getAllOptionals()]).then((response) => {
      if (this._isMounted) {
        this.setState({
          negotiationLotStateList: response[0].data,
          optionalsData: response[1].data
        });
      }
    }).catch((negLotStateListError, optionalsListError) => {
      if (this._isMounted)
        this.setState({
          openError: true,
          alertMessage: handleServerError(negLotStateListError || optionalsListError)
        });
    });
  };

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      openError: false,
      alertMessage: ''
    });
  };

  openEditFPLotMainForm(oNegLot) {
    if (this._isMounted)
      this.setState({
        showFPLotEditForm: !this.state.showFPLotEditForm,
        negotiationLot: oNegLot
      });
  };

  reloadFirmPurchasesLotsTableList() {
    if (this._isMounted) {
      this.setState({ shouldReloadList: true });
      this.setState({ shouldReloadList: false });
    }
  };


  render() {

    return (
      <div>
        <MuiThemeProvider theme={aquaBluePalette}>
          <NegotiationLotsTableList
            negotiationLotStateList={this.state.negotiationLotStateList}
            openEditFPLotMainForm={this.openEditFPLotMainForm.bind(this)}
            titleNegLot={this.props.titleTableListNegLot}
            titleTableList={this.props.titleTableList}
            showContent={this.props.showContent}
            shouldReloadList={this.state.shouldReloadList}
          />
          {!this.state.negotiationLot ?
            null
            :
            <FirmPurchasesLotEditForm
              open={this.state.showFPLotEditForm}
              reloadFirmPurchasesLotsTableList={this.reloadFirmPurchasesLotsTableList.bind(this)}
              optionalsData={this.state.optionalsData}
              openEditFPLotMainForm={this.openEditFPLotMainForm.bind(this)}
            />
          }
        </MuiThemeProvider>

        <SnackbarAlert openError={this.state.openError} alertMessage={this.state.alertMessage} handleCloseSnackbar={this.handleCloseSnackbar} />

      </div>
    )
  }
}

export default FirmPurchasesContent


// WEBPACK FOOTER //
// ./src/components/FirmPurchases/FirmPurchasesContent.js